export default __webpack_public_path__ + "static/media/AdminLightActive.f07d1df7.svg";